import {
  LIST_DATASHEET_MANAGEMENT_SUCCESS,
  LIST_DATASHEET_MANAGEMENT_ERROR,
  SAVE_DATASHEET_MANAGEMENT_SUCCESS,
  SAVE_DATASHEET_MANAGEMENT_ERROR,
  DELETE_DATASHEET_MANAGEMENT_SUCCESS,
  DELETE_DATASHEET_MANAGEMENT_ERROR,
  CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE,
  CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE,
  LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS,
  LIST_DATASHEET_MANAGEMENT_REQUEST
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  datasheetManagementList: [],
  allDatasheetList: [],
  datasheetManagementModel: null,
  success: '',
  error: null,
  errorType: null,
  sections: {}
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LIST_DATASHEET_MANAGEMENT_REQUEST:
      return { ...state, error: null, success: '' }

    case LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        allDatasheetList: action.payload,
        error: null
      }

    case LIST_DATASHEET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        allDatasheetList: action.payload.allListDatasheet,
        datasheetManagementList: action.payload.resultList || [],
        pages: action.payload.pages || {},
        error: null,
      }

    case LIST_DATASHEET_MANAGEMENT_ERROR:
      return { ...state, error: action.payload, success: '' }

    case SAVE_DATASHEET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        datasheetManagementModel: action.payload,
        success: 'datasheetManagement.save.success',
        error: null,
      }

    case DELETE_DATASHEET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        success: 'datasheetManagement.delete.success',
        error: null,
      }

    case SAVE_DATASHEET_MANAGEMENT_ERROR:
      return { ...state, error: action.payload, success: '', errorType: 'save' }

    case DELETE_DATASHEET_MANAGEMENT_ERROR:
      return {
        ...state,
        error: action.payload,
        success: '',
        errorType: 'delete',
      }

    case CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE:
      return { ...state, success: '', datasheetManagementModel: null }

    case CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE:
      return { ...state, error: null, errorType: null }
      
    default:
      return { ...state }
  }
}
